<ng-container *ngIf="cart$ | async as cart">
  <div
    class="cart-totals"
    *ngIf="{
      currentProfile: currentProfile$ | async,
      isBonusSystemEnabled: isBonusSystemEnabled$ | async,
    } as obs"
  >
    <span class="cart-totals__title">Итогo по заказу</span>

    <div *ngIf="cart" class="cart-totals__position-list">
      <div *ngIf="cart.subTotal" class="cart-totals__position">
        <span class="cart-totals__position-label">Сумма заказа:</span>
        <span class="cart-totals__position-separator"></span>
        <span class="cart-totals__position-amount">
          {{ cart.subTotal.formattedValue }}
        </span>
      </div>

      <div *ngIf="cart.totalDiscounts?.value" class="cart-totals__position">
        <span class="cart-totals__position-label">Скидка:</span>
        <span class="cart-totals__position-separator"></span>
        <span class="cart-totals__position-amount">
          {{ cart.totalDiscounts.formattedValue }}
        </span>
      </div>

      <div *ngIf="cart.deliveryCost?.value" class="cart-totals__position">
        <span class="cart-totals__position-label">Доставка:</span>
        <span class="cart-totals__position-separator"></span>
        <span class="cart-totals__position-amount">
          {{ cart.deliveryCost.formattedValue }}
        </span>
      </div>

      <div *ngIf="cart.deliveryServicesCost?.value" class="cart-totals__position">
        <span class="cart-totals__position-label">Доп. услуги:</span>
        <span class="cart-totals__position-separator"></span>
        <span class="cart-totals__position-amount">
          {{ cart.deliveryServicesCost.formattedValue }}
        </span>
      </div>

      <div
        *ngIf="
          obs.currentProfile &&
          obs.currentProfile.bonusBalance &&
          cart.totalBonusDiscounts &&
          cart.totalBonusDiscounts.value
        "
        class="cart-totals__position"
      >
        <span class="cart-totals__position-label">Баллы:</span>
        <span class="cart-totals__position-separator"></span>
        <span class="cart-totals__position-amount">-{{ cart.totalBonusDiscounts.formattedValue }}</span>
      </div>
    </div>

    <div *ngIf="cart" class="cart-totals__delivery">
      <span>вес {{ cart.weight }} кг</span>
      <span>
        объём {{ cart.volume }} м
        <sup>3</sup>
      </span>
    </div>

    <div
      class="cart-bonus"
      *ngIf="
        obs.currentProfile &&
        obs.currentProfile.bonusBalance &&
        (obs.currentProfile.bonusBalance.value || obs.currentProfile.bonusBalance.value === 0) &&
        obs.isBonusSystemEnabled
      "
    >
      <ng-container *ngIf="!obs.currentProfile.isLegal; else hiddenBonusTpl">
        <sd-checkout-bonus></sd-checkout-bonus>
      </ng-container>
      <ng-template #hiddenBonusTpl>Вы можете списать баллы переключившись на физическое лицо</ng-template>
    </div>

    <div class="cart-totals__cashback">
      <div class="cart-totals__bonus-widget" *ngIf="obs.isBonusSystemEnabled">
        <sd-bonus-widget [amount]="bonusAssignedAmount$ | async"></sd-bonus-widget>
        <span>баллов</span>
      </div>

      <div *ngIf="cart.totalPrice" class="cart-totals__total-price">
        <span class="cart-totals__total-price_text">Итого</span>
        <span class="cart-totals__total-price_value">
          {{ cart.totalPrice.formattedValue }}
        </span>
      </div>
    </div>

    <sd-submit-order class="cart-totals__button-order"></sd-submit-order>

    <div class="cart-totals__terms">
      <p>
        Нажимая кнопку “Оформить заказ” я подтверждаю согласие с условиями
        <a *ngIf="obs.isBonusSystemEnabled" [routerLink]="'/loyalty_program'">программы лояльности, &ensp;</a>
        <a [routerLink]="'/personal_data'">персональных данных</a>
        и
        <a [routerLink]="'/public_offer'">договором купли-продажи товаров.</a>
      </p>
    </div>
  </div>
</ng-container>
